import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Tabs } from '@components';
import { FEATURE_FLAGS } from '@constants/feature';
import { RoleType } from '@features/team-management/constants';
import Head from '@layouts/head/Head';
import { TabPill } from 'types/tabs';

import { CalendarIntegrationCard } from '../components/lead-settings';
import LeadSquaredConfiguration from '../components/lead-settings/LeadSquaredConfiguration';
import MetaIntegration from '../components/lead-settings/MetaIntegration';
import { LeadSettingIds, leadSettingsTabs } from '../constants/leadSettings';

const LeadSettings = () => {
  const { orgFeatureFlags, rolesAndPermissions } = useSelector(
    (state: any) => state.user
  );
  const isSalesAgent = rolesAndPermissions?.role === RoleType.SALES_AGENT;
  const isMetaLeadIngestionEnabled = orgFeatureFlags?.includes(
    FEATURE_FLAGS.META_LEAD_INGESTION
  );

  const tabVisibility: Record<string, boolean> = {
    [LeadSettingIds.LEAD_CONFIGURATION]: !isSalesAgent,
    [LeadSettingIds.META_INTEGRATION]: isMetaLeadIngestionEnabled
  };

  const filteredTabs = leadSettingsTabs.filter(
    (tab) => tabVisibility[tab.id] ?? true
  );

  const [selectedTab, setSelectedTab] = useState<TabPill>(filteredTabs[0]);
  const handleTabChange = (tab: TabPill) => {
    setSelectedTab(tab);
  };

  return (
    <div className="page bg-bgBase">
      <Head title="Settings" />
      <h1 className="text-2xl font-bold text-content">Settings</h1>
      <Tabs
        tabs={filteredTabs}
        selectedTab={selectedTab}
        onTabSelect={handleTabChange}
      />
      <div className="mt-6">
        {selectedTab.id === LeadSettingIds.CALENDAR_CONFERENCING && (
          <CalendarIntegrationCard />
        )}
        {selectedTab.id === LeadSettingIds.LEAD_CONFIGURATION && (
          <LeadSquaredConfiguration />
        )}
        {selectedTab.id === LeadSettingIds.META_INTEGRATION &&
          isMetaLeadIngestionEnabled && <MetaIntegration />}
      </div>
    </div>
  );
};

export default LeadSettings;
